import { useLocation, Link } from "react-router-dom";
import { G } from "@/brand";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";

const SUPPORT = "Brocque@promptsavant.io";

const DOCS = {
  privacy: {
    label: "PRIVACY POLICY", title: "Privacy Policy",
    body: [
      ["What we collect", "We collect your email address when you sign in via magic link, join a waitlist, or subscribe. We store your access tier, credit balance, prompts you open, AI edits you make, tracks you log, and feedback you submit — all tied to your account."],
      ["How we use it", "To operate PromptSavant.io: authenticate you, deliver purchased access, power AI prompt editing, send transactional and (if you opt in) launch emails, and improve the product based on real usage."],
      ["Payments", "Payments are processed by Stripe. We never see or store your full card details. We retain a purchase record (amount, tier, date) linked to your account."],
      ["Email", "Transactional emails (sign-in links, receipts, waitlist/subscription confirmations) are sent via Resend. You can unsubscribe from non-essential email at any time."],
      ["Your voice & content", "Prompt Savant is a text prompt library. Any voice-cloning features referenced in the suite (Vocal DNA Fingerprint) will only ever process your own voice, owned by you, and are not part of this app."],
      ["Your rights", `You may request access to or deletion of your data at any time by emailing ${SUPPORT}.`],
    ],
  },
  terms: {
    label: "TERMS OF SERVICE", title: "Terms of Service",
    body: [
      ["Acceptance", "By using PromptSavant.io you agree to these terms. If you don't agree, please don't use the service."],
      ["What you get", "Free tier grants access to 50 prompts. Vault ($19.99) and Codex ($59.99) are one-time purchases granting expanded prompt access, bundled credits, and in-app AI editing. Codex includes Vault. Prices shown add 6.5% NC tax at checkout."],
      ["Credits", "Paid tiers include bundled credits. Opening a premium prompt costs credits the first time (reopening is free). AI editing costs credits per action. Credits are non-transferable and have no cash value."],
      ["Acceptable use", "Prompts are licensed for your own music creation. You may not resell, redistribute, or scrape the prompt library. Automated bulk access is prohibited."],
      ["Availability", "We aim for high uptime but provide the service 'as is' without warranty. Features labeled 'Coming Soon' are roadmap items and not guaranteed."],
      ["Contact", `Questions? Email ${SUPPORT}.`],
    ],
  },
  refunds: {
    label: "REFUND POLICY", title: "Refund Policy",
    body: [
      ["One-time purchases", "Because Vault and Codex grant immediate digital access to the prompt library, purchases are generally non-refundable once premium content has been opened or AI edits have been used."],
      ["When we do refund", "If you were charged in error, could not access what you paid for due to a technical fault on our side, or request a refund within 7 days without having consumed premium credits, we'll make it right."],
      ["Credits", "Bundled credits are part of a one-time purchase and are not separately refundable."],
      ["How to request", `Email ${SUPPORT} with your account email and the purchase date. We respond within 2 business days.`],
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const key = pathname.replace("/", "");
  const d = DOCS[key] || DOCS.privacy;
  return (
    <div style={{ background: G.black, minHeight: "100vh" }}>
      <Nav />
      <div style={{ maxWidth: 820, margin: "0 auto", padding: "130px 5vw 80px" }}>
        <div className="mono" style={{ fontSize: 9, letterSpacing: "0.5em", color: G.gold, marginBottom: 14 }}>{d.label}</div>
        <h1 style={{ fontSize: "clamp(30px,5vw,52px)", fontWeight: 300, fontStyle: "italic", color: "#fff", marginBottom: 10 }}>{d.title}</h1>
        <div className="mono" style={{ fontSize: 10, color: G.goldDim, letterSpacing: ".1em", marginBottom: 40 }}>LAST UPDATED · JUNE 2026</div>
        {d.body.map(([h, p]) => (
          <div key={h} style={{ marginBottom: 28 }}>
            <div style={{ fontSize: 20, color: G.gold, fontStyle: "italic", marginBottom: 8 }}>{h}</div>
            <p style={{ color: G.text, fontSize: 15.5, lineHeight: 1.7 }}>{p}</p>
          </div>
        ))}
        <div style={{ borderTop: `1px solid ${G.border}44`, paddingTop: 24, marginTop: 20 }}>
          <div className="mono" style={{ fontSize: 10, letterSpacing: ".1em", color: G.goldDim }}>SUPPORT · <span style={{ color: G.gold }}>{SUPPORT}</span></div>
          <div style={{ marginTop: 16, display: "flex", gap: 16, flexWrap: "wrap" }}>
            <Link to="/privacy" className="mono" style={fl}>Privacy</Link>
            <Link to="/terms" className="mono" style={fl}>Terms</Link>
            <Link to="/refunds" className="mono" style={fl}>Refunds</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const fl = { color: G.muted, textDecoration: "none", fontSize: 10, letterSpacing: ".12em", textTransform: "uppercase" };
